<template>
  <el-form class="mt-3 flex flex-col items-stretch justify-start" :model="form" :rules="rules" ref="form">
    <slot></slot>
    <slot name="radio" />
    <div v-if="radioTypeInfoText && radioTypeInfoText.length > 0" class="mt-3 text-xs text-redG0">
      {{ $t(radioTypeInfoText) }}
    </div>
    <div class="mt-8 flex flex-col items-stretch justify-start">
      <slot name="form" />
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'InformationTemplate',
  props: {
    // radio slot
    // form slot
    form: { type: Object, required: true },
    rules: { type: Object, required: true },
    radioTypeInfoText: { type: String, default: '' }
  },
  methods: {
    validateField(props, callback) {
      this.$refs.form?.validateField(props, callback);
    },
    validate(callback) {
      this.$refs.form?.validate((valid, rules) => callback?.(valid, rules));
    },
    clearValidate(props) {
      this.$refs.form?.clearValidate(props);
    }
  }
};
</script>
